import WOW from 'wow.js'


// WOW は DOM が構築されてから初期化（UMD 由来の getComputedStyle ポリフィル対策）
document.addEventListener('DOMContentLoaded', () => {
  const wow = new WOW({
    live: false,
    boxClass: 'animate',      // HTML に合わせる
    animateClass: 'is-active',// CSS に合わせる
    offset: 0 ,
    mobile: true,
    scrollContainer: null,
  });
  wow.init();
});